export const isPerPerson = (price, group, type) => price > 0 && (type ? type === "kisi" : group === "mekan" && price < 5000);
